// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement } from "react";

import { FormattedMessage } from "react-intl";

export const OptionalLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.createApiPage.optionalLabel"
        description="Optional label."
        defaultMessage="Optional"
    />
);
OptionalLabel.displayName = "OptionalLabel";

export const CreateApiTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.createApiPage.createApiTitle"
        description="Create api title."
        defaultMessage="Create API"
    />
);
CreateApiTitle.displayName = "CreateApiTitle";

export const CancelButtonCta = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.createApiPage.cancelButtonCta"
        description="Cancel button cta."
        defaultMessage="Cancel"
    />
);
CancelButtonCta.displayName = "CancelButtonCta";

export const ApiSettingsStepLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.createApiPage.apiSettingsStepLabel"
        description="Api settings step label."
        defaultMessage="API Settings"
    />
);
ApiSettingsStepLabel.displayName = "ApiSettingsStepLabel";

export const EndpointsStepLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.createApiPage.endpointsStepLabel"
        description="Endpoints step label."
        defaultMessage="Endpoints"
    />
);
EndpointsStepLabel.displayName = "EndpointsStepLabel";

export const SubmitApiButtonCta = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.createApiPage.submitApiButtonCta"
        description="Submit api button cta."
        defaultMessage="Submit API"
    />
);
SubmitApiButtonCta.displayName = "SubmitApiButtonCta";
